<template>
    <div v-for="record in data.page.data" :key="rowKey(record)">
        <Row align="middle" justify="center">
            <Col :xs="24">
                <Card class="card-item">
                    {{ $t("model.vesselOwner.fullName") }}: {{ record.firstName }} <br />
                    {{ $t("model.vesselOwner.addr") }}: {{ record.addr }} <br />
                    {{ $t("model.vesselOwner.ownershipDate") }}: {{ record.ownershipDate }} <br />
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";
import { Card, Row, Col } from "ant-design-vue";
import { state as stateApp } from "../../../../../../app.logic";
import { initData, isLoading } from "./vessel-owner.logic";
import { rowKey } from "../../../../../../components/table/c-table.logic";

export default defineComponent({
    components: {
        Card,
        Row,
        Col,
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        dataProp: {},
        rowKey: { default: () => rowKey },
        itemsKey: {},
        visible: { default: true },
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });
        watch(
            () => (data.useForm?.modelRef?.licenseCode),
            () => initData({ props, data, refs }),
            { flush: "post" }
        );
        watch(
            () => (data.useForm?.modelRef?.refVesselRequest?.vesselOwnerRequests),
            () => initData({ props, data, refs }),
            { flush: "post" }
        );
        return { props, data, refs, isLoading, initData };
    },
});
</script>
